import React from 'react';
import { History } from 'history';
import { ISession } from 'interfaces/session/ISession';
import mappingHelpers from 'helpers/mappingHelpers';
import {
  Divider,
  FooterNote,
  FooterWrapper,
  MasterGameTable,
  ModalContent,
  SlaveGameTable,
  StyledModal,
  TableDividerText,
  Title,
} from './styles/MergeModalStyles';
import { Button } from '@trackman/web-shared-components';

interface IProps {
  visible: boolean;
  history: History;
  masterSession?: ISession;
  slaveSession?: ISession;
  isMergeInProgress: boolean;
  onDismissCallback: () => void;
  onMergeCallback: () => void;
}

export const MergeModal: React.FC<IProps> = ({
  visible,
  history,
  masterSession,
  slaveSession,
  onDismissCallback,
  onMergeCallback,
  isMergeInProgress,
}) => {
  if (!masterSession || !slaveSession) {
    return null;
  }
  return (
    <StyledModal open={visible} onClose={onDismissCallback} title='please confirm merge' fullWidth maxWidth='md'>
      <ModalContent>
        <Title>Master game</Title>
        <MasterGameTable
          data={[masterSession]}
          loading={false}
          columns={[
            { accessor: 'time', width: 150, Cell: (cellInfo: any, column: any) => mappingHelpers.timeDisplay(cellInfo.value) },
            { accessor: 'homeTeam.name' },
            { accessor: 'awayTeam.name' },
            { accessor: 'gameReference' },
            { accessor: 'id', width: 100, Cell: (cellInfo: any, column: any) => <></> },
          ]}
          pageSize={1}
          minRows={1}
          TheadComponent={(props: any) => null}
        />
        <TableDividerText>With</TableDividerText>
        <SlaveGameTable
          data={[slaveSession]}
          loading={false}
          columns={[
            { accessor: 'time', width: 150, Cell: (cellInfo: any, column: any) => mappingHelpers.timeDisplay(cellInfo.value) },
            { accessor: 'homeTeam.name' },
            { accessor: 'awayTeam.name' },
            { accessor: 'gameReference' },
            { accessor: 'id', width: 100, Cell: (cellInfo: any, column: any) => <></> },
          ]}
          pageSize={1}
          minRows={1}
          TheadComponent={() => null}
        />
        <Divider />
        <FooterWrapper>
          <FooterNote>Please note that this process is irreversible</FooterNote>
          <div>
            <Button intent='tertiary' label='Cancel' onClick={onDismissCallback} width='110px' />
            <Button intent='primary' label='Accept and merge' disabled={isMergeInProgress} onClick={onMergeCallback} width='150px' />
          </div>
        </FooterWrapper>
      </ModalContent>
    </StyledModal>
  );
};
